export { default } from './CodiEspectador';
